const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function persistUtmsFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  let saved = false;

  UTM_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      sessionStorage.setItem(key, value);
      saved = true;
    }
  });

  return saved;
}

export function getStoredUtms() {
  const utms = {};
  UTM_PARAMS.forEach((key) => {
    const value = sessionStorage.getItem(key);
    if (value) utms[key] = value;
  });
  return utms;
}

export function getUtmFromRecord(record = {}) {
  const origenParts = (record.origen || "").trim().split(/\s+/).filter(Boolean);

  return {
    utm_source: record.utm_source || origenParts[0] || "",
    utm_medium: record.utm_medium || origenParts[1] || "",
    utm_campaign: record.utm_campaign || "",
    utm_term: record.utm_term || "",
    utm_content: record.utm_content || "",
  };
}
